"use client";

// React Imports
import React, {useEffect} from "react";
import type {ReactNode} from "react";

// Next Imports
import {useSession} from "next-auth/react";

// Third-party Imports
import {Provider, useDispatch} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";

// Store Imports
import {store, persistor} from "@/redux-store";

// Redux Imports
import {doSetSettings} from "@/redux-store/slices/EntitySettings";

// Websocket Import
import WebSocketClient from "../configs/WebSocketClient";

const ReduxProvider = ({children, dictionary}: {children: ReactNode; dictionary: any}) => {
  const {status} = useSession();

  // to get entity setting and save into the store
  const EntityComponent = React.memo(() => {
    const dispatch = useDispatch();

    useEffect(() => {
      if (status && status === "authenticated") {
        const promise = dispatch(doSetSettings(undefined) as any);

        return () => {
          promise.abort();
        };
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
  });

  return (
    <Provider store={store}>
      <WebSocketClient dictionary={dictionary} />
      <PersistGate loading={null} persistor={persistor}>
        <EntityComponent />
        {children}
      </PersistGate>
    </Provider>
  );
};

export default ReduxProvider;
